import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const GiftIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <rect x="3" y="7" width="18" height="16" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15 7.99999C2.15 6.97827 2.97827 6.14999 4 6.14999H20C21.0217 6.14999 21.85 6.97827 21.85 7.99999V22C21.85 23.0217 21.0217 23.85 20 23.85H4C2.97828 23.85 2.15 23.0217 2.15 22V7.99999ZM4 7.84999C3.91716 7.84999 3.85 7.91715 3.85 7.99999V22C3.85 22.0828 3.91716 22.15 4 22.15H20C20.0828 22.15 20.15 22.0828 20.15 22V7.99999C20.15 7.91715 20.0828 7.84999 20 7.84999H4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 15.85H3V14.15H21V15.85Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.15 23V5H12.85V23H11.15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.15 3.99999C5.15 1.8737 6.87371 0.149994 9 0.149994C11.1263 0.149994 12.85 1.8737 12.85 3.99999V7.84999H9C6.87371 7.84999 5.15 6.12629 5.15 3.99999ZM9 1.84999C7.81259 1.84999 6.85 2.81258 6.85 3.99999C6.85 5.18741 7.81259 6.14999 9 6.14999H11.15V3.99999C11.15 2.81258 10.1874 1.84999 9 1.84999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.85 3.99999C18.85 1.8737 17.1263 0.149994 15 0.149994C12.8737 0.149994 11.15 1.8737 11.15 3.99999V7.84999H15C17.1263 7.84999 18.85 6.12629 18.85 3.99999ZM15 1.84999C16.1874 1.84999 17.15 2.81258 17.15 3.99999C17.15 5.18741 16.1874 6.14999 15 6.14999H12.85V3.99999C12.85 2.81258 13.8126 1.84999 15 1.84999Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default GiftIconFilled;
